import { render, staticRenderFns } from "./SSOLogin.vue?vue&type=template&id=0dbbfa21"
import script from "./SSOLogin.vue?vue&type=script&lang=js"
export * from "./SSOLogin.vue?vue&type=script&lang=js"
import style0 from "./SSOLogin.vue?vue&type=style&index=0&id=0dbbfa21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports